import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TextField } from 'common/components';
import { RequiredProfileInfo } from 'modules/corporate-settings/constants/requiredFields';
import { IFormEmergencyContact } from 'common/interfaces/additionalInfo';
import { useRenderIntlMessage } from 'common/hooks/useRenderIntlMessage';
import { useRecommendedFields } from 'common/hooks/useRecommendedFields';
import inputLabels from 'common/messages/inputLabels';

const EmergencyContactName: FC = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<IFormEmergencyContact>();

  const error = errors.emergencyName;
  const renderIntlMessage = useRenderIntlMessage();
  const { profileRecommendedFields: recommendedFields } = useRecommendedFields();
  const recommended = Boolean(recommendedFields?.get(RequiredProfileInfo.EmergencyContactInfo));

  return (
    <Controller
      control={control}
      name="emergencyName"
      defaultValue=""
      render={({ field }) => (
        <TextField
          {...field}
          label={renderIntlMessage(inputLabels.name)}
          variant="outlined"
          fullWidth
          error={!!error}
          helperText={error ? renderIntlMessage(error.message) : undefined}
          recommended={recommended}
        />
      )}
    />
  );
};

export default EmergencyContactName;
